<template>
  <div class="login">
    <div class="login-container">
      <div class="login-close" @click="goHome">
        <img src="../assets/close.png" alt="close" />
      </div>

      <!-- 标题：根据模式切换 -->
      <h1 class="login-title">
        {{
          mode === "login" ? "登录" : mode === "register" ? "注册" : "找回密码"
        }}
      </h1>

      <!-- 登录 / 注册 / 找回密码 表单 -->
      <div class="login-input">
        <!-- 手机号 -->
        <el-input placeholder="请输入手机号" v-model="form.phone">
          <template slot="prepend">+86</template>
        </el-input>

        <!-- 登录：密码 -->
        <template v-if="mode === 'login'">
          <el-input
            placeholder="密码"
            v-model="form.password"
            show-password
          ></el-input>
        </template>

        <!-- 注册 / 找回密码：验证码 -->
        <template v-else>
          <el-input placeholder="请输入验证码" v-model="form.code">
            <template slot="append">
              <span @click="handleGetCode">
                {{ countdown > 0 ? `${countdown}s` : "获取验证码" }}
              </span>
            </template>
          </el-input>
        </template>

        <!-- 注册 / 找回密码：密码 + 确认密码 -->
        <template v-if="mode === 'register' || mode === 'reset'">
          <el-input
            :placeholder="mode === 'reset' ? '新密码' : '输入密码'"
            v-model="form.password"
            show-password
          ></el-input>
          <el-input
            placeholder="确认密码"
            v-model="form.confirmPassword"
            show-password
          ></el-input>
        </template>
      </div>

      <!-- 主按钮 -->
      <div class="login-button" @click="handleSubmit">
        {{
          mode === "login" ? "登录" : mode === "register" ? "立即注册" : "提交"
        }}
      </div>

      <!-- 底部链接：根据模式切换 -->
      <div v-if="mode === 'login'" class="login-forget" @click="goReset">
        忘记密码
      </div>
      <div v-if="mode === 'login'" class="login-register">
        没有账号&nbsp;<span @click="goRegister">立即注册</span>
      </div>

      <div v-else-if="mode === 'register'" class="login-register">
        已有账号&nbsp;<span @click="goLogin">立即登录</span>
      </div>

      <div v-else class="login-register login-register--back">
        <img
          src="../assets/backIcon.png"
          alt="back"
          class="back-icon"
          @click="goLogin"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { sendMsg, register, login, resetPassword } from "@/api";

export default {
  name: "Login",
  data() {
    return {
      // 当前模式：login / register / reset
      mode: "login",
      form: {
        phone: "",
        code: "",
        password: "",
        confirmPassword: "",
      },
      // 验证码倒计时
      countdown: 0,
      timer: null,
    };
  },
  methods: {
    goHome() {
      // 跳转到首页路由（根据你的路由配置可改为 path: '/'）
      if (this.$router) {
        this.$router.push({ name: "Home" });
      }
    },
    goLogin() {
      this.mode = "login";
      this.resetForm();
    },
    goRegister() {
      this.mode = "register";
      this.resetForm();
    },
    goReset() {
      this.mode = "reset";
      this.resetForm();
    },
    resetForm() {
      this.form = {
        phone: "",
        code: "",
        password: "",
        confirmPassword: "",
      };
    },
    handleGetCode() {
      // 校验手机号
      if (!this.form.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      // 如果正在倒计时，不重复点击
      if (this.countdown > 0) {
        return;
      }

      // 调用发送验证码接口
      sendMsg(this.form.phone)
        .then((res) => {
          if (res.code === 1 || res.code === 200) {
            this.$message.success("验证码发送成功");
            // 开始倒计时
            this.countdown = 60;
            this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          } else {
            this.$message.error(res.msg || "发送失败");
          }
        })
        .catch((err) => {
          console.error("发送验证码失败:", err);
          this.$message.error("发送失败，请稍后重试");
        });
    },
    handleSubmit() {
      // 校验手机号
      if (!this.form.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      if (this.mode === "login") {
        // 校验密码
        if (!this.form.password) {
          this.$message.warning("请输入密码");
          return;
        }

        // 调用登录接口
        login(this.form.phone, this.form.password)
          .then((res) => {
            if (res.code === 1 || res.code === 200) {
              this.$message.success("登录成功");
              // 保存 token 到 localStorage
              localStorage.setItem("token", res.data.token);
              // 跳转到首页
              this.$router.push({ name: "Home" });
            } else {
              this.$message.error(res.msg || "登录失败");
            }
          })
          .catch((err) => {
            console.error("登录失败:", err);
            this.$message.error("登录失败，请稍后重试");
          });
      } else if (this.mode === "register") {
        // 校验验证码
        if (!this.form.code) {
          this.$message.warning("请输入验证码");
          return;
        }
        // 校验密码
        if (!this.form.password) {
          this.$message.warning("请输入密码");
          return;
        }
        if (this.form.password.length < 3) {
          this.$message.warning("密码长度不能少于6位");
          return;
        }
        // 校验确认密码
        if (this.form.password !== this.form.confirmPassword) {
          this.$message.warning("两次密码输入不一致");
          return;
        }

        // 调用注册接口
        register(this.form.phone, this.form.password, this.form.code)
          .then((res) => {
            if (res.code === 1 || res.code === 200) {
              this.$message.success("注册成功");
              // 注册成功后跳转到登录
              setTimeout(() => {
                this.goLogin();
              }, 1500);
            } else {
              this.$message.error(res.msg || "注册失败");
            }
          })
          .catch((err) => {
            console.error("注册失败:", err);
            this.$message.error("注册失败，请稍后重试");
          });
      } else {
        // TODO: 找回密码接口
        // 校验验证码
        if (!this.form.code) {
          this.$message.warning("请输入验证码");
          return;
        }
        // 校验密码
        if (!this.form.password) {
          this.$message.warning("请输入新密码");
          return;
        }
        if (this.form.password.length < 3) {
          this.$message.warning("密码长度不能少于3位");
          return;
        }
        // 校验确认密码
        if (this.form.password !== this.form.confirmPassword) {
          this.$message.warning("两次密码输入不一致");
          return;
        }

        // 调用重置密码接口
        resetPassword(
          this.form.phone,
          this.form.password,
          this.form.confirmPassword,
          this.form.code
        )
          .then((res) => {
            if (res.code === 1 || res.code === 200) {
              this.$message.success("密码重置成功");
              // 重置成功后跳转到登录
              setTimeout(() => {
                this.goLogin();
              }, 1500);
            } else {
              this.$message.error(res.msg || "重置失败");
            }
          })
          .catch((err) => {
            console.error("重置密码失败:", err);
            this.$message.error("重置失败，请稍后重试");
          });
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="scss">
.login {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-container {
  width: 100%;
  max-width: 400px;
  min-height: 430px;
  text-align: center;
  background: #ffffff;
  border-radius: 5px;
  padding: 51px 30px 27px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
}
.login-close {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  width: 22px;
  height: 22px;
  img {
    width: 100%;
    height: 100%;
  }
}
.login-input {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 输入框 placeholder 样式 */
.login-input ::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #909090;
}

/* “获取验证码”按钮样式 */
.login-input ::v-deep .el-input-group__append {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  cursor: pointer;
}
.login-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 23px;
  color: #90080e;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin: 0 auto;
  margin-bottom: 27px;
}
.login-button {
  // width: 340px;
  height: 50px;
  background: #90080e;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 19px;
  color: #ffffff;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  margin-top: 23px;
}
.login-forget {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  text-align: right;
  cursor: pointer;
  margin-top: 10px;
}
.login-register {
  border-top: 1px solid #efeded;
  padding-top: 20px;
  box-sizing: border-box;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  text-align: center;
  margin-top: auto;
  span {
    color: #1866b8;
    text-align: center;
    cursor: pointer;
  }
}
.back-icon {
  height: 42px;
  width: 42px;
  cursor: pointer;
  margin-top: 30px;
}

/* 找回密码时底部返回按钮居中 */
.login-register--back {
  border-top: none;
  padding-top: 0;
}

/* 平板（中屏）适配 */
@media (min-width: 769px) and (max-width: 1199px) {
  .login-container {
    max-width: 420px;
    padding: 40px 28px 24px;
  }
}

/* 手机端适配 */
@media (max-width: 768px) {
  .login {
    padding: 20px;
    box-sizing: border-box;
  }

  .login-container {
    max-width: 100%;
    padding: 32px 20px 20px;
    min-height: auto;
  }

  .login-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .login-button {
    width: 100%;
    font-size: 17px;
  }

  .login-register {
    font-size: 13px;
  }

  .login-input ::v-deep .el-input__inner::placeholder {
    font-size: 14px;
  }

  .login-input ::v-deep .el-input-group__append {
    font-size: 14px;
  }

  .back-icon {
    width: 36px;
    height: 36px;
  }
}

/* 超小屏进一步缩放 */
@media (max-width: 480px) {
  .login-title {
    font-size: 18px;
  }

  .login-button {
    height: 44px;
    line-height: 44px;
    font-size: 16px;
  }
}
</style>
